// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3_y-P","resendInfoText":"OnGoingPaymentBox_resendInfoText__1aYQr"};